<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ETcKXI/tc-custom/9781488074233.jpg?1728326983589" alt="This image is the cover for the book Fair Juno"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fair Juno
      </h1>
      <p class="bookDescription body article font2">
        <b>A widow rescued from kidnappers finds herself at the mercy of her seductive protector in this Regency romance from a <i>New York Times</i>–bestselling author.</b><br/><br/>When the Earl of Merton suddenly finds himself playing the knight in shining armor to a damsel in distress, he knows his days as a notorious rake are numbered. But though the lady seems grateful for his assistance, she flees the scene without revealing her name. And though past scandals and present dangers threaten his pursuit of the mysterious lady, he knows she is to be his destiny.<br/><br/><b>Praise for Stephanie Laurens</b><br/><br/>“Laurens’ writing shines.” —<i>Publishers Weekly</i><br/><br/>“Stephanie Laurens’ heroines are marvelous tributes to Georgette Heyer: feisty and strong.” —Cathy Kelly, #1 <i>Sunday Times</i>–bestselling author of <i>The Wedding Party</i><br/><br/>“All I need is her name on the cover to make me pick up the book.” —Linda Howard, <i>New York Times</i>–bestselling author of <i>An Independent Wife</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Laurens
      </h2>
      
      <p class="authorDescription body article">New York Times bestselling author Stephanie Laurens originally began writing as an escape from the dry world of professional science. Her hobby quickly became a career; she has been writing historical romance novels for more than 20 years. Currently living outside Melbourne, Australia with her husband and two cats, she spends most of her days writing new stories in her signature 'Errol Flynn meets Jane Austen&quot; style. Visit her online at www.stephanielaurens.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32e18fac